import React from "react"
import { Form } from "formik"
import { TextAreaField, FormStep, TextField } from "@theguarantors/ui-kit-v2"
import { Row, Col } from "@theguarantors/ui-kit-v2/dist/layout/grid"
import { useSelector } from "react-redux"
import { Props } from "./NoApartmentForm.types"
import { SubmitButton, BackButton, ErrorMessage } from "./NoApartmentForm.styles"
import { useHistoryActions } from "../../../../history"
import { LGQuestionnaireStore } from "../../../../types/store.types"
import { shouldDisableSubmitButton } from "@theguarantors/ui-kit-v2/dist/utils/one-column-form"
import { useBeforeUnload } from "@theguarantors/ui-kit-v2/dist/hooks"
import { FeatureFlag, useFeatureFlag } from "../../../../hooks/use-feature-flag"

export function NoApartmentFormComponent({ dirty, isSubmitting }: Props) {
  const [rebrandV2MonolithReact] = useFeatureFlag(FeatureFlag.REBRAND_V2_MONOLITH_REACT)
  const rebrandV2MonolithReactFeatureFlag: Boolean = rebrandV2MonolithReact === "on"
  const { goToLandingPage } = useHistoryActions()

  useBeforeUnload(dirty)
  const errorMessage = useSelector((state: LGQuestionnaireStore) => state.noApartment.error)
  return (
    <Form noValidate data-testid="no-apartment-form">
      <Row vgutter={["s", "xl"]}>
        <Col>
          <TextField data-testid="email" name="email" placeholder="Email Address" required />
        </Col>
      </Row>
      <Row vgutter={["s", "xl"]}>
        <Col>
          <TextField data-testid="brokerName" name="brokerName" placeholder="Broker's Name" />
        </Col>
      </Row>
      <Row vgutter={["s", "xl"]}>
        <Col>
          <TextField data-testid="brokerEmail" name="brokerEmail" placeholder="Broker's Email" />
        </Col>
      </Row>
      <Row vgutter={["s", "xl"]}>
        <Col>
          <TextAreaField data-testid="details" name="details" placeholder="Please tell us more…" required />
        </Col>
      </Row>
      <ErrorMessage data-testid="general-error-message">{errorMessage}</ErrorMessage>
      <FormStep.Actions>
        <SubmitButton
          data-testid="submit-button"
          variant={rebrandV2MonolithReactFeatureFlag ? "v2_primary" : "primary"}
          type="submit"
          disabled={shouldDisableSubmitButton({ dirty, isSubmitting })}
          children="Submit"
        />
        <BackButton data-testid="back-button" variant="link" type="button" onClick={goToLandingPage}>
          Back
        </BackButton>
      </FormStep.Actions>
    </Form>
  )
}
